import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {SurchargeAuditReportModel} from "./surcharge-audit-report-model";
import {
    EntityGroupByReportCriteriaComponent
} from "../../../reports/common-report-criteria/entity-group-by-report-criteria/entity-group-by-report-criteria.component";
@Component({
    selector: "wbo-surcharge-audit-report",
    templateUrl: "./surcharge-audit-report.component.html",
    providers: [provideReportModel(SurchargeAuditReportModel)]
})
export class SurchargeAuditReportComponent extends AbstractReportPage {
    EntityGroupByReportCriteriaComponent = EntityGroupByReportCriteriaComponent;

    constructor(public model: SurchargeAuditReportModel) {
        super();
    }
}
